import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

import { CollapsibleFieldSection } from './CollapsibleFieldSection';
import { useAppSelector } from 'modules/state-mgmt/store';
import { getStoredFieldDisplayValue, getStoredImageUrls, expandEmailOrMobilePhoneField } from '../constants/workerFieldsMap';
import { useStyles } from '../styles';
import ImagePdfPreview from 'modules/views/shared/ImagePdfPreview';

export const StoredFieldsSection = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { workerCustomProfileFields, onboarding, languageCode } = useAppSelector(state => ({
    workerCustomProfileFields: state.cache.project?.workerSettings?.workerCustomProfileFields ?? [],
    onboarding: state.onboarding,
    languageCode: state.app?.languageCode ?? 'en',
  }));

  const storedFields = useMemo(() => {
    const allFields = workerCustomProfileFields as any[];
    const visibleStoredFields = allFields.filter((f: any) => f.isStored && f.isVisible);
    const expanded = expandEmailOrMobilePhoneField(visibleStoredFields, onboarding?.email, onboarding?.mobilePhoneNumber, allFields);
    return [...expanded.filter((f: any) => f.dataType !== 6), ...expanded.filter((f: any) => f.dataType === 6)];
  }, [workerCustomProfileFields, onboarding]);

  if (!storedFields.length) return null;

  return (
    <>
      <div className={classes.sectionGap} />
      <CollapsibleFieldSection title={t('consentForm.step2.storedFields')} classes={classes}>
        <div className={classes.companyFormContainer}>
          <Grid container spacing={3}>
            {storedFields.map((field: any) => {
              const isImage = field.dataType === 6;
              const imageUrls = isImage ? getStoredImageUrls(field.code, onboarding) : [];
              const displayValue = isImage
                ? null
                : getStoredFieldDisplayValue(field.code, onboarding, languageCode, field.dataType);

              return (
                <Grid item xs={12} lg={isImage ? 12 : 6} key={field.fieldId}>
                  <div>
                    <p className={classes.storedFieldLabel}>{field.name}</p>
                    {isImage ? (
                      imageUrls.length > 0 && (
                        <div className={classes.storedFieldImageRow}>
                          {imageUrls.map((url, i) => (
                            <ImagePdfPreview
                              key={i}
                              url={url}
                              alt={field.name}
                              imageClassName={classes.storedFieldImage}
                            />
                          ))}
                        </div>
                      )
                    ) : (
                      <p className={classes.storedFieldValue}>{displayValue}</p>
                    )}
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </CollapsibleFieldSection>
    </>
  );
};
